import {Pipe, PipeTransform} from "@angular/core";
import {OrganizationType} from "@portal/api/enums/organization-type";

@Pipe({ name: 'orgTypeName' })

export class OrganatizationTypePipe implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case OrganizationType.Club:
                return 'Clube';
            case OrganizationType.Party:
                return 'Festa Popular';
            case OrganizationType.Tuna:
                return 'Tuna';
            case OrganizationType.Association:
                return 'Associação';
            default:
                return 'Tipo Desconhecido';
        }
    }
}
